import { render, staticRenderFns } from "./FootballTeamCard.vue?vue&type=template&id=481c7908&scoped=true"
import script from "./FootballTeamCard.vue?vue&type=script&lang=js"
export * from "./FootballTeamCard.vue?vue&type=script&lang=js"
import style0 from "./FootballTeamCard.vue?vue&type=style&index=0&id=481c7908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481c7908",
  null
  
)

export default component.exports